<template>
  <vs-row>
    <vs-row class="my-5 mx-4">
      <vs-col vs-lg="5" vs-sm="12">
        <vs-row>
          <vs-dropdown>
            <vs-button
              class="ml-0 pr-5 font-semibold"
              type="filled"
              icon="expand_more"
              :color="actionBtnClr"
              icon-after
              >Action</vs-button
            >
            <vs-dropdown-menu class="viewDropdown">
              <vs-dropdown-item
                :disabled="selected.length <= 0"
                @click="confirmDelete = true"
              >
                Delete
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
          <vs-button
            class="pl-4 ml-4"
            type="border"
            icon-pack="feather"
            icon="icon-plus"
            @click="editCard('')"
            >Add Card</vs-button
          >
          <!-- <vs-button
            :disabled="selected.length <= 0"
            class="pl-8 ml-4 font-semibold center"
            type="filled"
            :color="actionBtnClr"
            @click="confirmDelete = true"
            >Delete</vs-button 
          >-->
        </vs-row>
      </vs-col>
      <vs-col vs-lg="3" vs-sm="12"> </vs-col>
      <vs-col vs-lg="4" vs-sm="12">
        <vs-row vs-type="flex" vs-justify="flex-end">
          <input
            maxLength="30"
            type="text"
            name="search"
            class="search px-4 w-1/3 py-3 shadow-lg"
            placeholder="Search..."
            @input="getCardsList('search')"
            v-on-clickaway="closeColorList"
            @click="handleFilter"
            v-model="search"
            autocomplete="off"
          />
        </vs-row>
        <vs-row>
          <div class="dropdown2 mt-1 w-full" id="maindropdown">
            <div class="dropdown2-content" v-show="toggleColorList">
              <div
                class="colorItemContainer"
                @click="searchIssuer(issuer.name)"
                :key="index"
                v-for="(issuer, index) in issuersList"
              >
                <div
                  class="colorIconStyle"
                  :style="{ 'background-color': issuer.color }"
                ></div>
                <span class="colorTextStyle">{{ issuer.name }}</span>
              </div>
            </div>
          </div>
        </vs-row>
      </vs-col>
    </vs-row>
    <vs-row class="tblBgClrPending shadow-lg mx-4">
      <vs-table
        id="table1"
        multiple
        v-model="selected"
        :max-items="itemsPerPage"
        :data="allCardsList"
        class="w-full"
        hoverFlat
        noDataText=""
      >
        <template slot="thead">
          <vs-th> IMAGE</vs-th>

          <vs-th class="th-left-aligned" sort-key="order_status"
            >CREDIT CARD NAME</vs-th
          >
          <vs-th sort-key="order_status">ISSUER</vs-th>

          <vs-th sort-key="order_status">ANNUAL FEES</vs-th>

          <vs-th sort-key="order_status">POINTS</vs-th>
          <vs-th sort-key="order_status">ACTIVE RULES</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr
              vs-align="center"
              style="word-wrap: anywhere"
              :data="tr"
              :key="indextr"
              v-for="(tr, indextr) in data"
            >
              <vs-td
                class="img-container center"
                @click.native.stop="viewDetails(tr._id)"
              >
                <vue-load-image>
                  <img
                    slot="image"
                    :src="
                      tr.photo
                        ? $ApiKeys.IMAGE_BASE_URL + tr.photo
                        : require('@/assets/images/no_preview.jpg')
                    "
                    width="77"
                    height="49"
                  />
                  <img
                    slot="preloader"
                    src="@/assets/images/image-loader.gif"
                    width="77"
                    height="49"
                  />
                  <div slot="error">
                    <img
                      slot="image"
                      :src="require('@/assets/images/no_preview.jpg')"
                      width="77"
                      height="49"
                    />
                  </div>
                </vue-load-image>
              </vs-td>

              <vs-td @click.native.stop="viewDetails(tr._id)">
                <p class="font-medium">
                  {{ tr.name ? tr.name : "Not Available" }}
                </p>
              </vs-td>
              <vs-td class="center" @click.native.stop="viewDetails(tr._id)">
                <p class="font-medium">
                  {{
                    tr.issuer && tr.issuer.name
                      ? tr.issuer.name
                      : "Not Available"
                  }}
                </p>
              </vs-td>
              <vs-td class="center" @click.native.stop="viewDetails(tr._id)">
                <p class="font-medium">
                  {{ tr.annual_fee ? tr.annual_fee : "Not Available" }}
                </p>
              </vs-td>

              <vs-td class="center" @click.native.stop="viewDetails(tr._id)">
                <div
                  v-if="tr.points_categories && tr.points_categories.length > 0"
                >
                  <div
                    :key="index"
                    v-for="(points, index) in tr.points_categories"
                  >
                    <p>
                      {{
                        points.points_category && points.points_category.name
                          ? (points.multiplier
                              ? points.multiplier + " x "
                              : "") + points.points_category.name
                          : "Not Available"
                      }}
                    </p>
                  </div>
                </div>
                <div v-else>
                  <p>{{ "Not Available" }}</p>
                </div>
              </vs-td>
              <vs-td
                class="centerdate"
                @click.native.stop="viewDetails(tr._id)"
              >
                <p class="font-medium">
                  {{ tr.activeRules.length ? "YES" : "NO" }}
                </p>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>

      <vs-row
        class="noDataText"
        v-if="showData == true && allCardsList && allCardsList.length == 0"
      >
        <vs-col vs-lg="12" vs-sm="12">
          <vs-row vs-type="flex" vs-justify="center">
            <p>No Data Available</p>
          </vs-row>
        </vs-col>
      </vs-row>
      <vs-row
        class="my-6 w-full"
        vs-justify="center"
        v-if="allCardsList && allCardsList.length > 0"
      >
        <div style="width: max-content">
          <vs-pagination
            :total="totalPages"
            v-model="pageIndex"
            @change="getCardsList('pagination')"
            v-show="cardListHasData"
          ></vs-pagination>
        </div>
      </vs-row>
    </vs-row>
    <vs-row>
      <vs-row>
        <vs-popup
          class="holamundo details"
          :title="cardInfo.name"
          :active.sync="showDetails"
        >
          <img :src="$ApiKeys.IMAGE_BASE_URL + cardInfo.photo" class="title-icon" />
          <vs-row>
            <vs-row class="detailsBorder p-4">
              <vs-row>
                <vs-col vs-lg="6">
                  <p class="detailLabel pt-1">Issuer</p>
                  <p class="detailContent pb-1">
                    {{ cardInfo ? cardInfo.issuer.name : "Not Available" }}
                  </p>
                  <p class="detailLabel pt-1">Card</p>
                  <p class="detailContent pb-1">
                    {{ cardInfo ? cardInfo.name : "Not Available" }}
                  </p>
                  <p class="detailLabel pt-1">Product Change</p>
                  <p class="detailContent pb-1">
                    {{
                      cardInfo.product_change
                        ? cardInfo.product_change.name
                        : "Not Available"
                    }}
                  </p>
                </vs-col>
                <vs-col vs-lg="6">
                  <p class="detailLabel pt-1">Card Type</p>
                  <p class="detailContent pb-1">
                    {{
                      cardInfo.card_type ? cardInfo.card_type : "Not Available"
                    }}
                  </p>
                  <p class="detailLabel pt-1">Upgrade Card</p>
                  <p class="detailContent pb-1">
                    {{
                      cardInfo.upgrade_card
                        ? cardInfo.upgrade_card.name
                        : "Not Available"
                    }}
                  </p>
                  <p class="detailLabel pt-1">Downgrade Card</p>
                  <p class="detailContent pb-1">
                    {{
                      cardInfo.downgrade_card
                        ? cardInfo.downgrade_card.name
                        : "Not Available"
                    }}
                  </p>
                </vs-col>
              </vs-row>
              <vs-row class="inputContainer p-0">
                <vs-checkbox
                  v-model="cardInfo.five_twenty_four"
                  vs-name="rule-type"
                  :vs-value="true"
                  class="m-2 mt-5 ml-0"
                  :disabled="true"
                />
                <div class="detailContent pt-5">Counts toward Chase 5/24</div>
            </vs-row>
            </vs-row>
            <vs-row class="detailsBorder p-4">
              <vs-col vs-lg="6">
                <p class="detailLabel pt-1">Annual Fee</p>
                <p class="detailContent pb-1">${{ cardInfo.annual_fee }}</p>
                <!-- <p class="detailLabel pt-1">Effective Fee Description</p>                               
                                <p v-if="cardInfo.effective_fee_description" class="detailContent pt-1" v-html="cardInfo.effective_fee_description"></p>
                                <p class="detailContent pt-1" v-else>Not Available</p> -->
              </vs-col>
              <vs-col vs-lg="6">
                <p class="detailLabel">Points</p>
                <p
                  class="detailContent"
                  v-if="
                    cardInfo.points_categories &&
                    cardInfo.points_categories.length == 0
                  "
                >
                  Not Available
                </p>
                <div v-if="cardInfo.points_categories">
                  <p
                    class="detailContent"
                    :key="index"
                    v-for="(category, index) in cardInfo.points_categories"
                  >
                    {{ category.multiplier }} x
                    {{ category.points_category ?  category.points_category.name : '' }}
                  </p>
                </div>
              </vs-col>
            </vs-row>
            <vs-row class="p-4">
              <vs-col
                v-if="cardInfo.activeRules && cardInfo.activeRules.length > 0"
              >
                <vs-row class="mb-2">
                  <img
                    :src="require('@/assets/images/active-rules/scale.png')"
                    class="rulesIcon mr-2"
                  />
                  <p class="detailLabel">Active Rules</p>
                </vs-row>
                <div
                  class="ml-6"
                  :key="ruleIndex"
                  v-for="(rule, ruleIndex) in cardInfo.activeRules"
                >
                  <p class="p-2 whiteText font-semibold" v-if="rule.rule">
                    {{ rule.rule.name }}
                  </p>
                  <div class="p-2 pt-0 whiteText" v-if="rule.rule">
                    {{ rule.rule.description }}
                  </div>
                </div>
              </vs-col>
              <vs-col
                v-if="cardInfo.activeRules && cardInfo.activeRules.length == 0"
              >
                <p class="detailLabel">No Active Rules</p>
              </vs-col>
            </vs-row>
            <vs-row vs-justify="center" v-show="cardInfo">
              <vs-button class="font-semibold" @click="editCard(cardInfo)"
                >Edit Card Details</vs-button
              >
            </vs-row>
          </vs-row>
        </vs-popup>
      </vs-row>
    </vs-row>
    <vs-popup
        class="holamundov"
        title="Status"
        :active.sync="showDeleteStatus.status"
      >
        <h5>{{ showDeleteStatus.msg }}</h5>
    </vs-popup>
    <vs-popup class="holamundo" title="Status" :active.sync="confirmDelete">
      <h5>Are you sure that you want to delete?</h5>
      <vs-row vs-justify="flex-end">
        <vs-button @click="deleteCards" class="mr-4">Yes</vs-button>
        <vs-button @click="confirmDelete = false">No</vs-button>
      </vs-row>
    </vs-popup>
  </vs-row>
</template>

<script>
import { MenuIcon, XIcon } from "vue-feather-icons";
import { mixin as clickaway } from "vue-clickaway";

import { validateIssuerName, validateCardName } from "@/views/admin/validation";
import { genericErrorMessage, toast } from "@/keys/toast-messages";
import VueLoadImage from "vue-load-image";

import EventBus from "@/event-bus.js";

export default {
  components: {
    MenuIcon,
    XIcon,
    VueLoadImage,
  },
  mixins: [clickaway],
  data() {
    return {
      firstRender:false,
      timer: false,
      confirmDelete: false,
      cardsList: [],

      actionBtnClr: "#1D2024",
      allCardsList: [],
      search: "",

      cardListHasData: true,
      pageIndex: 1,
      totalPages: 1,

      selected: [],
      itemsPerPage: 10,

      issuersList: [],
      toggleColorList: false,
      showDeleteStatus: {
        msg: "",
        status: false,
      },
      showDuplicateStatus: {
        msg: "",
        status: false,
      },
      errors: {
        cardName: {
          msg: "",
          success: false,
        },
      },
      genericErrorMessage,
      toast,
      datatoedit: "",
      datatoduplicate: "",
      isdelete: "",
      cardInfo: "",
      showDetails: false,
      showData: false,
    };
  },
  filters: {
    capitalize: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.toUpperCase();
    },
  },
  methods: {
    async deleteCards() {
      this.confirmDelete = false;
      if (this.selected.length == 0) {
        this.showDeleteStatus = {
          msg: "Please select atleast one card to delete",
          status: true,
        };
      } else {
        this.$vs.loading({
          background: "rgba(1,2,3,.2)",
        });
        this.showDeleteStatus = {
          msg: "",
          status: false,
        };
        let cardIds = [];
        await this.selected.forEach(async function (item, index) {
          cardIds.push(item._id);
        });

        return new Promise((resolve, reject) => {
          this.$axios
            .delete(
              this.$ApiKeys.BASE_URL + this.$EndPoints.Cards,
              {
                data: cardIds,
              }
            )
            .then(async (res) => {
              this.$vs.loading.close();
              if (res.data.success == true) {
                this.showDeleteStatus = {
                  msg: res.data.data.message,
                  status: true,
                };
                if (this.search.trim() != "") {
                  this.getCardsList("search");
                } else {
                  this.getCardsList();
                }
              } else {
                const errorMsg = res.data && res.data.response && res.data.response.errors && res.data.response.errors.length > 0 ? res.data.response.errors[0] : null
                if(errorMsg){
                  this.showDeleteStatus = {
                    msg: errorMsg,
                    status: true,
                  };
                }else{
                  this.toast(this.genericErrorMessage());
                } 
              }
            })
            .catch((e) => {
              this.$vs.loading.close();
              if (e.response.data.error && e.response.data.error.cards) {
                this.showExistingUsersStatus = {
                  msg: e.response.data.error.cards,
                  status: true,
                };
                this.existingUsers = e.response.data.data;
              } else {
                this.showExistingUsersStatus = {
                  msg: "",
                  status: false,
                };
                this.existingUsers = [];
              }
              if (e.response.data.errors && e.response.data.errors.cardId) {
                this.showDeleteStatus = {
                  msg: e.response.data.errors.cardId,
                  status: true,
                };
              } else {
                this.showDeleteStatus = {
                  msg: "",
                  status: false,
                };
              }
              if (
                !e.response.data.error &&
                !e.response.data.error.cards &&
                !e.response.data.errors.cardId
              ) {
                if (e.response.status !== 401) {
                  this.toast(this.genericErrorMessage());
                }
              }
            });
        });
      }
    },
    async editCard(cardInfo) {
      if (cardInfo) {
        await this.closeDetails();
        await this.$router.push({
          name: "edit-card",
          params: {
            card: cardInfo,
            up: this.cardInfo.upgrade_card,
            down: this.cardInfo.downgrade_card,
            pro: this.cardInfo.product_change,
          },
        });
      } else {
        await this.$router.push({ path: "/view-cards/add-card" });
      }
    },
    closeDetails() {
      this.showDetails = false;
    },
    searchIssuer(inp) {
      this.search = inp;
      this.getCardsList("search");
    },
    async handleFilter() {
      this.toggleColorList = true;
    },
    closeColorList() {
      if (this.toggleColorList) {
        this.toggleColorList = false;
      }
    },
    async getCardsList(name) {
      if(name=='pagination' && this.firstRender==false){
        this.firstRender=true
        return
      }
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        //this.selected = [];
        this.$vs.loading.close();
        this.$vs.loading({
          background: "rgba(1,2,3,.2)",
        });
        if (
          this.isdelete &&
          this.allCardsList.length == this.selected.length &&
          this.pageIndex > 1
        ) {
          this.pageIndex -= 1;
        }
        this.selected = [];
        return new Promise(async (resolve, reject) => {
          await this.$axios
            .get(this.$ApiKeys.BASE_URL + this.$EndPoints.Cards, {
              params: {
                keyword: this.search,
                page: name == "search" ? 1 : this.pageIndex,
                perPage: this.itemsPerPage,
              }
            })
            .then(async (res) => {
              this.$vs.loading.close();
              this.showData = true;
              if (res.data.success) {
                this.$root.$emit("updateApprovals", {});
                if (name == "search") {
                  this.pageIndex = 1;
                }
                res.data.data.allCards[0].metaData.length?this.totalPages = Math.ceil(res.data.data.allCards[0].metaData[0].total / 
                this.itemsPerPage):0
                resolve(
                  //console.log(res.data)
                  (this.allCardsList = res.data.data.allCards.length?
                    res.data.data.allCards[0].cards : []),
                  (this.issuersList = res.data.data.allIssuers),
                  (this.cardListHasData = true)
                );
              } else {
                this.toast(this.genericErrorMessage());
              }
            })
            .catch((e) => {
              this.$vs.loading.close();
              if (e.response.status == 404) {
                this.cardListHasData = false;
                this.allCardsList = [];
              }
              if (e.response.status !== 401 && e.response.status !== 404) {
                this.toast(this.genericErrorMessage());
              }
            });
        });
      }, 500);
    },
    viewDetails(rowId) {
      this.getCardInfo(rowId);
    },
    getCardInfo(id) {
      this.$vs.loading({
        background: "rgba(1,2,3,.2)",
      });
      return new Promise((resolve, reject) => {
        this.$axios
          .get(this.$ApiKeys.BASE_URL + this.$EndPoints.Cards + "/" + id)
          .then(async (res) => {
            this.$vs.loading.close();
            if (res.data.success) {
              this.showDetails = true;
              let cardInfoData = res.data.data[0]
              if(cardInfoData.points_categories &&
              cardInfoData.points_categories[0] &&
              cardInfoData.points_categories[0].multiplier
                === undefined)
                {
                  cardInfoData.points_categories=[]
                }
              resolve((this.cardInfo = cardInfoData));
            } else {
              this.toast(this.genericErrorMessage());
            }
          })
          .catch((e) => {
            this.$vs.loading.close();
            // console.log('Error in getCardInfo: ',e);
            if (e.response.status !== 401) {
              this.toast(this.genericErrorMessage());
            }
          });
      });
    },
  },

  created() {
    EventBus.$emit("resetToggleGroup", true);
    this.getCardsList();
  },

  mounted() {
    if (this.$route.params.search != undefined) {
      this.search = this.$route.params.search;
      this.getCardsList("search");
    }
  },
};
</script>

<style>
@import "./style.css";
</style>

